import React, { Children, useMemo, useState } from "react";
import {
  Button,
  FormControl,
  OutlinedInput,
  Stack,
  Backdrop,
  CircularProgress,
  AppBar,
  Grid,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import { Clear, ClearAll } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import { GetChatContent } from "../../../utilities/chatgptconn";
import { InsertAIGenText } from "../../../utilities/Wordutil";
import axiosBaseURL from "../../../utilities/httpCommon";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";

/* global console */

const ChatComponent = () => {
  const messagesource = {
    padding: "4px",
    width: "100%",
    color: "#fafafa",
    marginTop: "4px",
    display: "flex",
    "justify-content": "flex-end",
  };

  const messagesystem = {
    background: "#6785bd",
    color: "#fafafa",
    padding: "4px",
    marginTop: "4px",
    "border-radius": "5px",
  };

  const messageuser = {
    background: "#579697",
    color: "#fafafa",
    padding: "4px",
    marginTop: "4px",
    "border-radius": "5px",
  };

  const messageassistant = {
    background: "#644c98",
    color: "#fafafa",
    padding: "1px",
    marginTop: "4px",
    "border-radius": "5px",
  };

  const initialMessages = [
    {
      role: "system",
      content: "You are a helpful assistant.",
    },
    {
      role: "user",
      content: "Hello!",
    },
  ];
  const [IsLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState(initialMessages);
  const [currentUserReq, setCurrentUserReq] = useState("");
  const [errMsgd, seterrMsgd] = useState("");

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const getClass = (role) => {
    if (role === "assistant") {
      return messageassistant;
    }
    if (role === "system") {
      return messagesystem;
    }
    if (role === "user") {
      return messageuser;
    }
    return messagesystem;
  };
  const InsertAction = async (msgtext: any) => {
    await InsertAIGenText(msgtext);
  };
  const onSendMessage = async () => {
    let msg = messages;
    if (currentUserReq?.length) {
      msg = [...messages, { role: "user", content: currentUserReq }];
    }
    const options = {
      body: JSON.stringify({ messages: msg }),
    };
    console.log(options);

    try {
      //Check for validation
      setIsLoading(true);
      const resauth = await axiosBaseURL
        .get("/sfserver/auth/validate", {
          withCredentials: true,
        })
        .catch((error: any) => {
          setIsLoading(false);
          if (error.response) {
            console.log(error.response);
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
          return null;
        });
      setIsLoading(false);
      if (resauth === null) {
        return;
      }
      //Ends here

      setIsLoading(true);
      const res = await GetChatContent(msg);
      const data = await res.data;
      console.log(data);
      if (Array.isArray(data?.choices) && data.choices.length && data.choices[0].message) {
        setMessages([...msg, data.choices[0].message]);
        setCurrentUserReq("");
      }
      console.log(messages);
      setIsLoading(false);
    } catch (e) {
      console.log("Somenting went wrong ", e);
      setIsLoading(false);
    }
  };
  const messagesChatReversed = useMemo(() => {
    return messages.reverse();
  }, [messages]);

  return (
    <>
      <Box>
        {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
        <div>
          {Array.isArray(messages) &&
            Children.toArray(
              messagesChatReversed.map((message) => (
                <div style={getClass(message?.role)}>
                  <div>
                    {message?.role === "assistant" && (
                      <Button
                        variant="outlined"
                        sx={{ background: "white", color: "black" }}
                        onClick={() => InsertAction(message?.content)}
                      >
                        Use in doc
                      </Button>
                    )}
                    <div style={messagesource}>{message?.role}</div>
                  </div>
                  <div>
                    {message?.content?.split("\n").map((i, key) => {
                      return <div key={key}>{i}</div>;
                    })}
                  </div>
                </div>
              ))
            )}
        </div>
      </Box>
      <AppBar position="fixed" sx={{ top: "auto", bottom: 0, marginTop: 10 }}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl sx={{ width: "100%" }}>
              <OutlinedInput
                placeholder="Please enter your question"
                value={currentUserReq}
                onChange={(e) => setCurrentUserReq(e?.target?.value)}
                sx={{ background: "white", color: "black" }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={onSendMessage} edge="end">
                      <SendIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Stack direction="row" spacing="{1}" justifyContent="space-between">
              {/* <Button size="small" variant="contained" endIcon={<SendIcon />} onClick={onSendMessage}>
            Send
          </Button> */}
              <Button size="small" variant="contained" endIcon={<Clear />} onClick={() => setCurrentUserReq("")}>
                Clear
              </Button>
              <Button
                size="small"
                variant="contained"
                endIcon={<ClearAll />}
                onClick={() => setMessages(initialMessages)}
              >
                Reset Chat
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </AppBar>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ChatComponent;
